import { render } from "./PostAudioPlayer.vue?vue&type=template&id=abc2d808&scoped=true"
import script from "./PostAudioPlayer.vue?vue&type=script&lang=js"
export * from "./PostAudioPlayer.vue?vue&type=script&lang=js"

import "./PostAudioPlayer.vue?vue&type=style&index=0&id=abc2d808&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-abc2d808"

export default script